export const downloadFile = async (uri: string, filename: string) => {
  /// force https
  const url = uri.replace('http://', 'https://')

  const link = document.createElement('a')
  link.setAttribute('href', url)
  link.setAttribute('download', filename)
  // link.setAttribute('target', '_blank')
  // link.setAttribute('rel', 'nofollow')
  link.click()
}

export const downloadLargeFile = async (uri: string, filename: string) => {
  /// force https
  const url = uri.replace('http://', 'https://')

  const link = document.createElement('a')
  link.setAttribute('href', url)
  // link.
  // link.setAttribute('download', filename)
  link.setAttribute('target', '_blank')
  // link.setAttribute('rel', 'nofollow')
  link.click()
}

export const downloadFileWithinJs = async (uri: string, filename: string) => {
  const resp = await fetch(uri)
  const blob = await resp.blob()

  const url = (URL.createObjectURL(blob) as any) as string
  const a = document.createElement('a')
  a.style.display = 'none'
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  a.remove()
  URL.revokeObjectURL(url)
}

export const downloadFileWithHeaders = async (
  uri: string,
  filename: string,
  headers: Record<string, string> = {}
) => {
  const url = uri.replace('http://', 'https://')
  const resp = await fetch(url, {
    method: 'GET',
    headers,
    credentials: 'include',
  })

  if (!resp.ok) {
    return
  }

  const contentType = resp.headers.get('content-type') || ''
  const extensionMap: Record<string, string> = {
    'image/jpeg': 'jpg',
    'image/png': 'png',
    'image/webp': 'webp',
    'image/gif': 'gif',
    'image/bmp': 'bmp',
    'image/tiff': 'tiff',
    'image/avif': 'avif',
    'video/mp4': 'mp4',
    'video/webm': 'webm',
    'video/quicktime': 'mov',
  }
  const normalizedType = contentType.split(';')[0].trim()
  const detectedExtension = extensionMap[normalizedType]
  const hasExtension = /\.[^/.]+$/.test(filename)
  const resolvedFilename = detectedExtension
    ? hasExtension
      ? filename.replace(/\.[^/.]+$/, `.${detectedExtension}`)
      : `${filename}.${detectedExtension}`
    : filename

  const blob = await resp.blob()
  const objectUrl = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.style.display = 'none'
  link.href = objectUrl
  link.download = resolvedFilename
  document.body.appendChild(link)
  link.click()
  link.remove()
  URL.revokeObjectURL(objectUrl)
}
